import React, { FC } from 'react';
import styles from './index.module.scss';
import intl from 'react-intl-universal';
import { ErrorBoundaryProps, ErrorBoundaryState } from './index'

const ComponentError: FC<ErrorBoundaryProps & ErrorBoundaryState> = (props) => {
  const { error, errorText = intl.get('ERROR_COMPONENT_DEFAULT_TEXT') } = props;

  return(
    <div className={styles.componentErrorWrap}>
      <div className={styles.errorTips}>
        <img className={styles.errorImg} src={require('@/assets/vod/icon/states_16px_failed.png')}></img>
        <span className={styles.errorText}>{ errorText }</span>
      </div>
      <p className={styles.errorMessage}>{ error?.msg || error?.message }</p>
    </div>
  )
}

export default ComponentError;